import React from "react"
import Layout from "../components/Layout/Layout";
import { graphql } from "gatsby";
import '../templates/stylesheets/post.scss';
import Casts1 from "../components/casts/casts_1"
import Casts2 from "../components/casts/casts_2"

export const pageQuery = graphql`
  query markdown($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        title
        startDate
        endDate
        eventId
        thumbnail {
          name
        }
      }
    }
  }
`

export default ({ data }) => {
  const html = data.markdownRemark.html;
  const { title, startDate, endDate, eventId } = data.markdownRemark.frontmatter;
  if (eventId == 1) {
    return (
      <Layout>
        <div className="main-article-wrapper">
          <article className="main-article">
            <h1 className="main-article-title">
              {title}
            </h1>
            <div className="main-article-event-date">開催期間： {startDate} 〜 {endDate}</div>
            <div className="main-article-body" dangerouslySetInnerHTML={{ __html: html }} />
            <h1 className="main-article-casts">出品者</h1>
            <Casts1/>
          </article>
        </div>
      </Layout>
    )
  } else if (eventId == 2) {
    return (
      <Layout>
        <div className="main-article-wrapper">
          <article className="main-article">
            <h1 className="main-article-title">
              {title}
            </h1>
            <div className="main-article-event-date">開催期間： {startDate} 〜 {endDate}</div>
            <div className="main-article-body" dangerouslySetInnerHTML={{ __html: html }} />
            <h1 className="main-article-casts">出品者</h1>
            <Casts2/>
          </article>
        </div>
      </Layout>
    )
  } else {
    return (
      <Layout>
        <div className="main-article-wrapper">
          <article className="main-article">
            <h1 className="main-article-title">
              {title}
            </h1>
            <div className="main-article-event-date">Event Date： {startDate} 〜 {endDate}</div>
            <div className="main-article-body" dangerouslySetInnerHTML={{ __html: html }} />
          </article>
        </div>
      </Layout>
    )
  }
}